export default {
	classNameWrapper: "",
	tag: "p",
	size: "md",
	typeStyle: {},
};
